import { useContext, useEffect, useState } from "react";
import { FormContext } from "../Context/FormContext";
export const combine = (target, source) => {
    const newTarget = {};
    Object.keys(target).forEach((key) => {
        newTarget[key] = source[key];
    });
    return target;
};
const useStepPersistence = (data, formData, setFormData) => {
    const [local, setLocal] = useState(data);
    const { setDirty } = useContext(FormContext);
    useEffect(() => {
        const newData = {};
        if (!Object.keys(formData).length) {
            return;
        }
        Object.keys(data).forEach((key) => {
            if (formData[key] === undefined) {
                newData[key] = data[key];
            }
            else {
                newData[key] = formData[key];
            }
        });
        setLocal(Object.assign(Object.assign({}, local), newData));
    }, [formData]);
    const handleChange = (e) => {
        const { name, value, type, dataset } = e.currentTarget;
        const asType = dataset.asType || "auto";
        let persistingValue = value;
        setDirty(true);
        if (["auto", "boolean"].indexOf(asType) > -1) {
            if (type === "radio" && value === "yes")
                persistingValue = true;
            if (type === "radio" && value === "no")
                persistingValue = false;
            if (type === "checkbox") {
                persistingValue = e.currentTarget.checked;
            }
        }
        if (["currency_amount"].indexOf(asType) > -1) {
            if ((persistingValue + "").match(/^(\d+([,.]\d{2})?)?$/)) {
                e.currentTarget.setCustomValidity("");
            }
            else {
                e.currentTarget.setCustomValidity("Bedrag moet bijvoorbeeld 50,41 zijn");
            }
        }
        setLocal(Object.assign(Object.assign({}, local), { [name]: persistingValue }));
    };
    const patch = (updateData) => {
        const newData = {};
        Object.keys(data).forEach((key) => {
            if (updateData[key] !== undefined) {
                newData[key] = updateData[key];
            }
        });
        setLocal(Object.assign(Object.assign({}, local), newData));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        setFormData(local);
    };
    return [local, handleChange, handleSubmit, patch];
};
export default useStepPersistence;
